import { useMutation } from "@tanstack/react-query";
import { UpdateOrganizerParams, updateOrganizer } from "supabase/organizers";
import { queryClient } from "utils";

export const useUpdateOrganizer = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: (organizer: UpdateOrganizerParams) => {
      return updateOrganizer(organizer);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["organizers"],
      });
      queryClient.invalidateQueries({
        queryKey: ["organizer", variables.uid],
      });

      onSuccess();
    },
  });

  return mutation;
};
